import {Component, OnInit, inject} from '@angular/core';
import {I18nService} from '../../_services/gui/i18n.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    imports: [TranslateModule]
})
export class TermsComponent implements OnInit {
  private i18nService = inject(I18nService);


  ngOnInit() {
    this.i18nService.setTitle('title.terms-of-use');
  }

}
